import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';

export const StyledTableCell = styled(TableCell)(() => ({
  verticalAlign: 'top',
  width: '50%',
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.grey[300],
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1, 0, 1, 0),
}));

export const StyledHeadingTypography = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0, 0, 1, 0),
}));

export const StyledOl = styled('ol')(({ theme }) => ({
  '& ul': {
    marginBottom: '0 !important',
  },
  marginBottom: theme.spacing(2),
}));

export const StyledUl = styled('ul')(({ theme }) => ({
  '& ul': {
    marginBottom: '0 !important',
  },
  marginBottom: theme.spacing(2),
}));
